import { QueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import i18next from 'i18next'
import { financialStatementsKeys } from '../../features/financialStatements/queries/financialStatementsQueryKeys'
import customReportQueryKeys from '../../features/customReport/queries/customReportQueryKeys'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      experimental_prefetchInRender: true,
      // globally default to 1 minutes
      staleTime: 1000 * 60 * 1
    },
    mutations: {
      onError: () => {
        message.error(i18next.t('mutation:error:message:default'))
      }
    }
  }
})

// Global mutation observer to invalidate financial statements when budgeting-related mutations succeed
// This ensures that when you navigate back to financial statements page, data is refetched
queryClient.getMutationCache().subscribe(event => {
  if (event.type === 'updated' && event.mutation.state.status === 'success') {
    const mutationKey = event.mutation.options.mutationKey as unknown[] | undefined

    // Check if mutation is budgeting-related (tagged with 'budget')
    const isBudgetingRelated = mutationKey?.includes('budget')

    if (isBudgetingRelated) {
      // Invalidate financial statements and custom report sections - will refetch when user navigates back
      queryClient.invalidateQueries({
        queryKey: financialStatementsKeys.all
      })
      queryClient.invalidateQueries({
        queryKey: customReportQueryKeys.sections()
      })
    }
  }
})
